import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // questions
    questions: [],
    progress: [{
        label: 'Sign',
        seen: false,
        done: false
      },
      {
        label: 'Share',
        seen: false,
        done: false
      },
      {
        label: 'Donate',
        seen: false,
        done: false
      }
    ],
    current: 125,
    goal: 1000,

    progressExtras: 0,

    // general
    copy: {  
      slug: '',
      title: '',
      meta: {
        title: '',
        desc: '',
        image: '',
        whatsapp: '',
      },
      header: {
        title: '',
        subtitle: ''
      },
      questions: [],
      signAsk: {
        image: '',
        imageMob: '',
        title: '',
        copy: ``,
        question: ``,
        yes_btn: '',
        no_btn: ''
      },
      sign: {
        image: '',
        imageMob: '',
        title: '',
        subTitle: '',
        subTitle_quote: false,
        petitionTitle: '',
        EN_URL: ''
      },
      shareAsk: { // / results screen
        image: '',
        imageMob: '',
        question: ``,
        yes_btn: ``,
        no_btn: ``
      },
      donateAsk: {
        image: '',
        imageMob: '',
        title: ``,
        copy: ``,
        yes_btn: ``,
        donate_link: ``,
        no_btn: ``
      },
      thanks: {
        image: '',
        imageMob: '',
        title: ``,
        copy: ``,
        btn_text: ``,
        btn_link: ``
      }
    },
    slides: ['question_1'],
    headerHeight: 82,
    progressBarHeight: 66,
    width: 0,
    form: {
      // placeholder for any input fields that are used
      firstname: '',
      email_opt_in: 0
    },
    supporter: false,
  },
  mutations: {
    updateProgress(state, payload) {
      let index
      state.progress.map((el, i) => {
        if (el.label == payload.label) index = i
      })
      state.progress[index].done = payload.done
      state.progress[index].seen = payload.seen
    },
    // general
    setHeaderHeight(state, payload) {
      state.headerHeight = payload
    },
    setWidth(state, payload) {
      state.width = payload
    },
    updateForm(state, payload) {
      state.form[payload.id] = payload.value
    },
    addSlide(state, payload) {
      state.slides.push(payload)
    },
    addQuestions(state, payload) {
      state.questions = payload;
    },
    addCopy(state, payload) {
      state.copy = payload;
    },
    answerQuestion(state, payload) {
      state.questions[payload.question].userAnswer = payload.answer
    },
    updateTest(state, payload) {
      state.tests[payload.test] = payload.variant
    },
    updateExtraProgress(state) {
      if (state.progressExtras < (state.supporter ? 2 : 3)) {
        state.progressExtras += 1
      }
    },
    supporter(state) {
      state.supporter = true
    },
    updateShareDescription(state, payload) {
      state.copy.meta.whatsapp = payload.shareDesc;
    }
  },
  actions: {},
  getters: {
    showSlide: state => id => {
      return state.slides.indexOf(id) != -1
    },
    getHeaderHeight: (state) => (payload) => {
      let height;
      if (state.width < 768) {
        height = payload.mobHeight;
      } else {
        if (payload.shrinkAfterFirstSlide) {
          if (state.slides.length > 1) {
            height = payload.shrinkHeight;
          } else {
            height = payload.height;
          }
        } else {
          height = payload.height;
        }

      }

      state.headerHeight = height;

      return height
    },
    getProgressBarHeight: (state) => (payload) => {
      let height;
      if (state.width < 768) {
        height = payload.mobHeight;
      } else {
        height = payload.height;
      }

      state.progressBarHeight = height;

      return height
    },
    replaceFirstName: state => text => {
      return text.replace('[firstname]', state.form.firstName)
    },
    // donate 
    getAmounts: state => {
      return state.donate.amounts ? state.donate.amounts[state.donateType] : []
    },
    getFancyAmount: state => {
      return state.donateAmount ? '£' + state.donateAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : null;
    },
    progressPerc: state => {
      const totalQs = state.questions.length + (state.supporter ? 2 : 3)
      let answeredQs = state.progressExtras
      state.questions.forEach((q) => {
        q.userAnswer != null ? answeredQs += 1 : null;
      })
      return ((answeredQs / totalQs) * 100).toFixed(0)
    },
    getScore: state => {
      let score = 0;
      state.questions.forEach((q) => {
        q.userAnswer == q.answer ? score += 1 : null;
      })
      return score;
    }
  }
})